import type { FC } from 'react';
import { BreadcrumbsBase } from '@mwl/ui';
import ArrowBackIcon from '@public/assets/common/icons/arrowBack.svg';
import ArrowRightIcon from '@public/assets/common/icons/arrowRightOutlined.svg';
import { useMediaWidthDown } from '@/hooks';
import type { PerfectScrollbarProps } from '../PerfectScrollbar/PerfectScrollbar';
import { PerfectScrollbar } from '../PerfectScrollbar/PerfectScrollbar';
import type { BreadcrumbsProps } from './Breadcrumbs.types';
import styles from './Breadcrumbs.module.scss';
const scrollbarOptions: PerfectScrollbarProps['options'] = {
  suppressScrollX: false,
  suppressScrollY: true,
  useBothWheelAxes: true
};
const Breadcrumbs: FC<BreadcrumbsProps> = ({
  className,
  classes,
  isLastActive,
  children
}) => {
  const isXsScreen = useMediaWidthDown('screenXs');
  const separatorComponent = isXsScreen ? <ArrowBackIcon className={styles.arrowBack} /> : <ArrowRightIcon className={styles.arrowSeparator} />;
  return <PerfectScrollbar className={styles.scrollbar} options={scrollbarOptions} data-sentry-element="PerfectScrollbar" data-sentry-component="Breadcrumbs" data-sentry-source-file="Breadcrumbs.tsx">
      <BreadcrumbsBase className={className} classes={{
      separator: cn(styles.separator, classes?.breadcrumbsItem.separator),
      itemWrapper: cn(styles.itemWrapper, classes?.breadcrumbsItem.itemWrapper),
      item: cn(styles.item, classes?.breadcrumbsItem.item)
    }} separator={separatorComponent} isShortView={isXsScreen} isLastActive={isLastActive} data-sentry-element="BreadcrumbsBase" data-sentry-source-file="Breadcrumbs.tsx">
        {children}
      </BreadcrumbsBase>
    </PerfectScrollbar>;
};
export { Breadcrumbs };